import React from 'react';
import { Row, Col} from 'reactstrap';

const DataFetchError = () => (
  <Row>
    <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
      <h2>
        Sorry!
      </h2>
      <p>
        Er is helaas een fout opgetreden bij het laden. Probeer het later nog eens.
      </p>
    </Col>
  </Row>
);

export default DataFetchError



// WEBPACK FOOTER //
// ./src/registrationform/DataFetchError.jsx